// https://hofk.de/main/discourse.threejs/2022/DynamicTubeGeometry/DynamicTubeGeometry.html
function DynamicTubeGeometry(
  radius,
  radialSegments,
  heightSegments,
  withTop,
  withBottom
) {
  const g = new THREE.BufferGeometry();

  g.radius = radius;
  g.heightSegments = heightSegments;
  g.radialSegments = radialSegments;

  let indices = [];
  let uvs = [];

  let index = 0;
  let indexArray = [];
  let groupStart = 0;

  let groupCount = 0;

  for (let y = 0; y <= heightSegments; y++) {
    let indexRow = [];

    let v = y / heightSegments;

    for (let x = 0; x <= radialSegments; x++) {
      uvs.push(x / radialSegments, 1 - v);
      indexRow.push(index++);
    }

    indexArray.push(indexRow);
  }

  let a, b, c, d;

  for (let i = 0; i < radialSegments; i++) {
    for (let j = 0; j < heightSegments; j++) {
      a = indexArray[j][i];
      b = indexArray[j + 1][i];
      c = indexArray[j + 1][i + 1];
      d = indexArray[j][i + 1];

      indices.push(a, b, d);
      indices.push(b, c, d);

      groupCount += 6;
    }
  }

  g.addGroup(groupStart, groupCount, 0);

  groupStart += groupCount;

  let verticesCount = (radialSegments + 1) * (heightSegments + 1);

  //if ( withTop ) generateCap( true );
  //if ( withBottom ) generateCap( false );

  g.setIndex(new THREE.BufferAttribute(new Uint32Array(indices), 1));
  g.setAttribute(
    "position",
    new THREE.BufferAttribute(new Float32Array(verticesCount * 3), 3)
  );
  g.setAttribute("uv", new THREE.BufferAttribute(new Float32Array(uvs), 2));

  function generateCap(top) {
    // ..................
  }

  g.update = function (radius, points) {
    // sets the coordinate of all vertices
    g.radius = radius;
    g.pts = new THREE.CatmullRomCurve3(points, false).getSpacedPoints(
      g.heightSegments
    ); // new center points

    // tangent( direction),  normal, binormal, shape in space

    let v3a = new THREE.Vector3();
    let v3b = new THREE.Vector3();

    let tangent = new THREE.Vector3();
    let normal = new THREE.Vector3(0, 0, -1); // first normal to after ...
    let binormal = new THREE.Vector3();

    let idx = 0;

    for (let i = 0; i <= g.heightSegments; i++) {
      if (i === 0) tangent.subVectors(g.pts[1], g.pts[0]);
      if (i > 0 && i < g.heightSegments)
        tangent.subVectors(g.pts[i + 1], g.pts[i - 1]);
      if (i === g.heightSegments) tangent.subVectors(g.pts[i], g.pts[i - 1]);

      binormal.crossVectors(normal, tangent);
      normal.crossVectors(tangent, binormal);

      binormal.normalize();
      normal.normalize();

      for (let j = 0; j <= g.radialSegments; j++) {
        // circle in space
        v3a.addVectors(
          binormal
            .clone()
            .multiplyScalar(Math.sin((Math.PI * 2 * j) / g.radialSegments)),
          normal
            .clone()
            .multiplyScalar(Math.cos((Math.PI * 2 * j) / g.radialSegments))
        );

        v3a.multiplyScalar(g.radius);

        v3b.addVectors(g.pts[i], v3a);

        g.attributes.position.setXYZ(idx++, v3b.x, v3b.y, v3b.z);
      }
    }

    idx--; // idx = ( g.radialSegments + 1 ) * ( g.heightSegments + 1 ) - 1; // last index torso

    /*    
        if( withTop ) {
            
            let x, y, z;
            
            g.attributes.position.setXYZ( ++ idx, g.pts[ 0 ].x, g.pts[ 0 ].y, g.pts[ 0 ].z ); // center top
            
            for( let j = 0; j <= g.radialSegments ; j ++ ) {
                
                x = g.attributes.position.getX( j );
                y = g.attributes.position.getY( j );
                z = g.attributes.position.getZ( j );
                
                g.attributes.position.setXYZ( ++ idx, x, y, z );
                
            }
            
        }
        
        if( withBottom ) {
            
            let x, y, z, idxBtm;
            
            g.attributes.position.setXYZ( ++ idx, g.pts[ g.heightSegments ].x, g.pts[ g.heightSegments ].y, g.pts[ g.heightSegments ].z ); // center bottom
            
            for( let j = 0; j <= g.radialSegments ; j ++ ) {
                
                idxBtm = ( g.radialSegments + 1 ) * ( g.heightSegments + 1 ) - 1 - g.radialSegments + j; // last index torso - g.radialSegments + j
                
                x = g.attributes.position.getX( idxBtm );
                y = g.attributes.position.getY( idxBtm);
                z = g.attributes.position.getZ( idxBtm );
                
                g.attributes.position.setXYZ( ++ idx, x, y, z );
                
            }
            
        }
*/
    g.attributes.position.needsUpdate = true;
    g.computeVertexNormals();
  };

  return g;
}

export { DynamicTubeGeometry };
